import React from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import pojo from "LIB/pojos";
import {
  HEIGHT,
  LENGTH,
  NET_HEIGHT,
  NET_LENGTH,
  NET_WEIGHT,
  NET_WEIGHT_OZ,
  NET_WEIGHT_UNIT,
  NET_WIDTH,
  WEIGHT,
  WEIGHT_UNIT,
  WIDTH
} from "MODULES/parts/constants";
import Form from "./DimensionsForm";

export default function EditDimensions({ open, close, part }) {
  const overrides = {
    weight: part.weight,
    length: part.length,
    width: part.width,
    height: part.height,
    net_weight_unit: (part.net_weight_unit || "lb").toString(),
    net_weight_oz: part.net_weight_oz
  };

  const initialValues = pojo(part).pick(
    WEIGHT,
    WEIGHT_UNIT,
    NET_WEIGHT,
    NET_WEIGHT_OZ,
    NET_WEIGHT_UNIT,
    WIDTH,
    LENGTH,
    HEIGHT,
    NET_WIDTH,
    NET_LENGTH,
    NET_HEIGHT
  );

  return (
    <Modal open={open} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit Dimension & Weight Details</h4>
      </Header>
      <Form
        close={close}
        initialValues={Object.assign(initialValues, overrides)}
        enableReinitialize
      />
    </Modal>
  );
}

EditDimensions.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  part: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/EditPart/EditDimensions.jsx